import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/survey`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const surveyApi = {
  getInfo: ({ params }) => {
    return instance().get('/info', {
      params,
      headers: {
        AUTHORIZATION: 'Bearer $2a$10$dpLMdCwFtBIlPzMHhyNv/elmeQqQV08aHscQBhO2jYf0jsPCooJfO'
      }
    })
  },
  getAll: ({ params }) => {
    return instance().get('/', { params })
  },
  getAnswers: ({ params }) => {
    return instance().get('/answer', { params })
  },
  getExportedAnswers: ({ params }) => {
    return instance().get('/answer/export', { params })
  },
  getSummary: ({ params }) => {
    return instance().get('/summary', { params })
  }
}

export default surveyApi



// WEBPACK FOOTER //
// ./src/api/survey.js